"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Dropdown = void 0;
var _ExpandMore = _interopRequireDefault(require("@tvg/fuse-icons/lib/ExpandMore"));
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _config = require("./config");
var _styledDropdown = require("./styled-dropdown");
var _excluded = ["className", "csMask", "dataTestId", "defaultOption", "helperText", "isRequired", "label", "placeholder", "onChange", "options", "size", "state", "componentId"],
  _excluded2 = ["label", "value", "name"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var componentName = _config.styledDropdownConfig.componentName,
  borderColor = _config.styledDropdownConfig.borderColor;
var icon = _config.config.icon;
var forwardRef = _react["default"].forwardRef,
  useRef = _react["default"].useRef,
  useState = _react["default"].useState,
  useCallback = _react["default"].useCallback;
var propTypes = {
  className: _propTypes["default"].string,
  csMask: _propTypes["default"].bool,
  dataTestId: _propTypes["default"].string,
  defaultOption: _propTypes["default"].string,
  helperText: _propTypes["default"].string,
  isRequired: _propTypes["default"].bool,
  label: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].string.isRequired
  }).isRequired),
  size: _propTypes["default"].string,
  state: _propTypes["default"].string,
  componentId: _propTypes["default"].string
};
var defaultProps = {
  className: 'fuse-dropdown',
  csMask: false,
  dataTestId: 'fuse-dropdown-data-test-id',
  defaultOption: '',
  helperText: undefined,
  isRequired: false,
  label: undefined,
  placeholder: 'Show options',
  onChange: undefined,
  options: [],
  size: 'large',
  state: undefined,
  componentId: (0, _fuseUtils.uuid)()
};
var Dropdown = exports.Dropdown = forwardRef(function (_ref, ref) {
  var className = _ref.className,
    csMask = _ref.csMask,
    dataTestId = _ref.dataTestId,
    defaultOption = _ref.defaultOption,
    helperText = _ref.helperText,
    isRequired = _ref.isRequired,
    label = _ref.label,
    placeholder = _ref.placeholder,
    onChange = _ref.onChange,
    options = _ref.options,
    size = _ref.size,
    state = _ref.state,
    componentId = _ref.componentId,
    rest = _objectWithoutProperties(_ref, _excluded);
  var selectLabelId = "".concat(componentName, "-dropdown-").concat(componentId);
  var helpTextId = "".concat(componentName, "-helper-text-").concat(componentId);
  var dropdownId = "".concat(componentName, "-dropdown-icon-").concat(componentId);
  var expandIconId = "".concat(componentName, "-dropdown-expand-icon-").concat(componentId);

  // Setting initial select value based on prop
  var _useState = useState(defaultOption),
    _useState2 = _slicedToArray(_useState, 2),
    dropdownValue = _useState2[0],
    setDropDownValue = _useState2[1];

  // Setting variable for disabled state
  var isDisabled = state === 'disabled';

  // Creating ID for helper message
  var helperTextId = helperText && helpTextId || '';

  // Creating ID for state icon (error/success icons)
  var dropdownStateIcon = state && (state === 'error' || state === 'success') && dropdownId || '';

  // Creating reference for select element
  var dropdownContainerRef = useRef();
  var dropdownSelectRef = useRef();

  // Handler to programmtically remove focus outline only when select has focus and is tabbed
  var handleContainerBlur = useCallback(function () {
    dropdownContainerRef.current.classList.remove("".concat(componentName, "__wrapper--outline"));
  }, []);

  // Handler to programmtically set focus outline only when select has focus and is tabbed
  var handleContainerKeyUp = useCallback(function (_ref2) {
    var keyCode = _ref2.keyCode;
    var tabKey = 9;
    if (keyCode === tabKey && document.activeElement === dropdownSelectRef.current) {
      dropdownContainerRef.current.classList.add("".concat(componentName, "__wrapper--outline"));
    }
  }, []);

  // Handler for on change of select element
  var handleSelectOnChange = useCallback(function (e) {
    var selectValue = e.currentTarget.value;
    if (onChange) onChange(e);
    dropdownContainerRef.current.classList.add("".concat(componentName, "__wrapper--selected"));
    setDropDownValue(selectValue);
  }, []);

  // Creating options components based on props & adding placeholder
  var getSelectOptions = useCallback(function (optionsArr) {
    var placeHolderOption = [{
      className: "".concat(componentName, "__option ").concat(componentName, "__option--placeholder"),
      label: placeholder,
      value: '',
      disabled: true
    }];
    var selectOptions = [].concat(_toConsumableArray(defaultOption === '' ? placeHolderOption : []), _toConsumableArray(optionsArr));
    return selectOptions.map(function (option, index) {
      var optionLabel = option.label,
        value = option.value,
        name = option.name,
        optionProps = _objectWithoutProperties(option, _excluded2);
      var optionId = "".concat(componentId, "__option_").concat(index);
      return /*#__PURE__*/_react["default"].createElement("option", _extends({
        className: "".concat(componentName, "__option"),
        key: optionId,
        name: name,
        value: value
      }, optionProps), optionLabel);
    });
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_styledDropdown.StyledWrapper, {
    ref: ref,
    className: "".concat(className).concat(isDisabled ? ' fuse-dropdown--disabled' : ''),
    "data-testid": dataTestId
  }, label && /*#__PURE__*/_react["default"].createElement(_styledDropdown.StyledLabel, {
    htmlFor: selectLabelId,
    size: size
  }, label, isRequired && ' *'), /*#__PURE__*/_react["default"].createElement(_styledDropdown.StyledDropdownWrapper, {
    state: state,
    size: size,
    ref: dropdownContainerRef,
    onBlur: handleContainerBlur,
    onKeyUp: handleContainerKeyUp
  }, /*#__PURE__*/_react["default"].createElement(_styledDropdown.StyledSelect, _extends({
    id: selectLabelId,
    "aria-describedby": "".concat(expandIconId, " ").concat(dropdownStateIcon, " ").concat(helperTextId),
    "aria-disabled": isDisabled,
    "aria-invalid": state === 'error' ? true : undefined,
    "aria-required": isRequired,
    disabled: isDisabled,
    isInDefaultState: state !== 'error' && state !== 'success',
    size: size,
    "data-cs-mask": csMask || undefined,
    onChange: handleSelectOnChange,
    ref: dropdownSelectRef,
    value: dropdownValue
  }, rest), getSelectOptions(options)), /*#__PURE__*/_react["default"].createElement(_styledDropdown.StyledIconWrapper, null, (icon === null || icon === void 0 ? void 0 : icon[state]) && /*#__PURE__*/_react["default"].createElement(_styledDropdown.StyledIcon, {
    color: borderColor === null || borderColor === void 0 ? void 0 : borderColor[state],
    icon: icon === null || icon === void 0 ? void 0 : icon[state].state,
    id: dropdownStateIcon,
    srLabel: icon === null || icon === void 0 ? void 0 : icon[state].label,
    responsiveSize: icon.size
  }), /*#__PURE__*/_react["default"].createElement(_styledDropdown.StyledExpandIcon, {
    icon: /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null),
    id: expandIconId,
    srLabel: "",
    responsiveSize: icon.size
  }))), (helperText === null || helperText === void 0 ? void 0 : helperText.length) > 0 && /*#__PURE__*/_react["default"].createElement(_styledDropdown.StyledDescriptionContainer, null, /*#__PURE__*/_react["default"].createElement(_styledDropdown.StyledHelperText, {
    id: helperTextId,
    type: "paragraph",
    size: "m1",
    state: state,
    tag: "p"
  }, (state === 'error' || state === 'success') && /*#__PURE__*/_react["default"].createElement(_fuseUtils.StyledScreenReaderSpan, null, state, ": "), helperText)));
});
Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;
var _default = exports["default"] = Dropdown;